import React from 'react';

interface IconProps {
  name: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, className = "w-6 h-6" }) => {
  const [svgContent, setSvgContent] = React.useState<string>('');

  React.useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(`/assets/icons/${name}.svg`);
        const svgText = await response.text();
        setSvgContent(svgText);
      } catch (error) {
        console.error(`Failed to load icon: ${name}`, error);
      }
    };

    fetchSvg();
  }, [name]);

  if (!svgContent) {
    return <div className={className} />; // Placeholder while loading
  }

  return (
    <div className={className}>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </div>
  );
};

export default Icon;
